import clsx from 'clsx/lite';
import { LinkButton } from '~/components/Buttons';
import type { Maybe } from '~/types/graphql';

type Props = {
  headline?: Maybe<string>;
  subhead?: Maybe<string>;
  cta?: Maybe<{
    title?: Maybe<string>;
    url?: Maybe<string>;
    target?: Maybe<string>;
  }>;
  className?: string;
  hideCtaMobile?: boolean;
  id?: string;
};

export function HeadlineSubheadCta({
  headline,
  subhead,
  cta,
  hideCtaMobile = false,
  id,
}: Props) {
  if (!headline && !subhead) return null;

  return (
    <div className="flex items-end justify-start gap-12 self-stretch" id={id}>
      {headline || subhead ? (
        <div className="flex shrink grow basis-0 flex-col items-start justify-start gap-6">
          {headline && (
            <h2 className="font-nova text-[34px] font-black uppercase lg:text-5xl">
              {headline}
            </h2>
          )}
          {subhead && (
            <div className="font-nova text-xl font-normal leading-[30px]">
              {subhead}
            </div>
          )}
        </div>
      ) : null}
      {!!cta?.url && (
        <LinkButton
          className={clsx(hideCtaMobile && 'max-lg:hidden')}
          href={cta.url}
          target={cta.target ?? undefined}
        >
          {cta.title ?? 'See More'}
        </LinkButton>
      )}
    </div>
  );
}
